/**
 * LiveStreamingCoinsStat — the live cumulative-coins pill.
 *
 * Web port of the Flutter `_coinsStats` app-bar action
 * (`lib/presentation/screens/community/live_streaming_screen.dart:1134-1176`): a
 * coin icon (`assets/images/coins.png`, exclusive-tinted, `:1156`) + the coins
 * tipped this session, in a rounded translucent pill. The value is formatted via
 * `MathUtils.getReactionsIntlNumber` (Flutter `:1164`, e.g. `1200 → "1.2K"`),
 * NOT shown raw. Pill markup lives in the shared `LiveStreamingStatPill` shell
 * (Task 5), which the sibling `LiveStreamingWatchersStat` also delegates to.
 *
 * Placement + visibility gating live on the page: Flutter shows the stats only
 * when `_firstFrameRendered && !_clearScreen && !_liveStreamingEnded
 * && !_isOpeningChannel` (`:1079-1084`), and orders them `[coins, watchers]`
 * (`:1086`), so this component neither re-derives that gate nor positions
 * itself. `data-qa-value` carries the raw coins count so QA can assert it.
 */

import React from 'react';

import { useTheme } from '@/presentation/contexts/ThemeContext';
import { MathUtils } from '@/domain/utils/mathUtils';
import { LiveStreamingStatPill } from './LiveStreamingStatPill';

export interface LiveStreamingCoinsStatProps {
  /** Cumulative coins tipped this session (`_coinsValueNotifier`, `:1161`). */
  coins: number;
}

export const LiveStreamingCoinsStat: React.FC<LiveStreamingCoinsStatProps> = ({
  coins,
}) => {
  const { theme } = useTheme();

  return (
    <LiveStreamingStatPill
      iconPath="/assets/images/coins.png"
      iconColor={theme.exclusive}
      value={MathUtils.getReactionsIntlNumber(coins)}
      qaId="live-streaming-coins"
      qaValue={coins}
    />
  );
};
